@if (isBootstrapping()) {
    <div class="d-flex flex-column vh-100 justify-content-center align-items-center text-center">
    <h1 class="fw-bold mb-3">
        Signing In
    </h1>
    <div class="spinner-border spinner-border-lg" role="status">
        <span class="visually-hidden">Redirecting...</span>
    </div>
</div>
}

<router-outlet />
